<div class="modal-container">
	<ib-generic-header
		[headerModel]="headerModel"
		[imgUrl]="imgUrl"
		[iconUrl]="iconUrl"
		(closeModal)="closeModal()">
	</ib-generic-header>
	<!-- body -->
	<main class="ib-layout">
		<section class="container">
			<div class="row">
				<div class="ib-table-row">
					<div class="col-xs-12 col-lg-8 u-mt-medium">
						<section>
							<h1 class="ib-heading ib-heading--type-1 u-mb-xsmall">
								{{'SEATS_DISRUPTION_REFUND_SEATS' | translate}}
							</h1>
							<h1 class="ib-text ib-text--block ib-text--medium u-mt-xsmall u-hide-mobile">
								{{'SEATS_DISRUPTION_REFUND_REMEMBER' | translate}}
							</h1>
							<div class="ib-profile-form u-mt-small u-pt-none u-mb-small u-pb-none">
								<div class="ib-profile-form ib-profile-form--border-small ib-profile-form--less u-p-xmedium">
									<span class="ib-profile-form__title ib-profile-form__title--x-small ib-profile-form__title--x-small-tablet u-mb u-hide-mobile">{{'SEATS_REFUND_BREAKDOWN' | translate}}</span>
									<div class="u-hide-mobile">
										<div class="table-header">	
											<span class="table-column-text table-column-text--column-1">{{'MMB_BOOKING_SEATS_TITLE' | translate}}</span>
											<div class="table-column-text--column header-separator">
												<span class="table-column-text">{{'MMB_PRICE_BREAKDOWN_PRICE' | translate}}</span>
											</div>
											<span class="table-column-text table-column-text--column">{{'MMB_GENERAL_TOTAL_TEXT' | translate}}</span>
										</div>
										<div class="u-display-flex u-border-bottom-s1-gray-50 u-mt u-pb" *ngFor="let segment of model.data.seatSegments">
											<div class="table-column-text--column-1">
												<p class="table-column-text">
													{{ segment.departureCity}} ({{ segment.departureAirport}}) - {{ segment.arrivalCity}} ({{ segment.arrivalAirport}})
												</p>
											</div>
											<div class="table-column-text--column">
												<p *ngFor="let seat of segment.seats" class="table-column-text">
														{{ seat.quantity}} x {{ seat.unitPrice | customCurrency: seat.currency}}
												</p>
											</div>
											<div class="table-column-text--column">
												<p *ngFor="let seat of segment.seats" class="table-column-text">
														{{ seat.total | customCurrency: seat.currency}}
												</p>
											</div>
										</div>
									</div>
									<!-- Mobile -->
									<div class="u-hide-desktop">
										<span class="ib-profile-form__title ib-profile-form__title--x-small ib-profile-form__title--x-small-tablet">
											{{'SEATS_REFUND_BREAKDOWN' | translate}}
										</span>
										<div class="u-border-top-s1-gray-50 u-mb"></div>
										<span class="payment-refund__text">
											{{'MMB_BOOKING_SEATS_TITLE' | translate}}
										</span>
										<div *ngFor="let segment of model.data.seatSegments" class="u-display-flex u-display-flex-space-between u-mt u-pb-small">
												<span class="trip-text">
													{{ segment.departureAirport}} - {{ segment.arrivalAirport}}
												</span>
											<div>
												<p *ngFor="let seat of segment.seats" class="seats-price">
													{{ seat.quantity}} x {{ seat.unitPrice | customCurrency: seat.currency}}
												</p>
											</div>
										</div>
										<div class="u-border-top-s1-gray-50 u-mt-small u-mb-small"></div>
									</div>
									<!-- End Mobile -->
									<div class="total-table">
										<span class="ib-text--especial total-table__text">
											{{'MMB_CASH_REFUND_MODAL_BREAKDOWN_TOTAL_PRICE_TITLE' | translate}}
										</span>
										<span class="ib-text--especial total-table__text">
											{{ model.data.totalRefund.amount | customCurrency: model.data.totalRefund.currency}}
										</span>
									</div>
								</div>
							</div>
						</section>
						<section>
							<span class="refund-text">
								{{'SEATS_DISRUPTION_REFUND_CHOOSE' | translate}}
							</span>
							<div class="voucher-refund">
								<div class="voucher-refund__banner-discount u-hide-mobile">
									<span class="icon-discount-3"></span>
									<span>
										{{'SEATS_DISRUPTION_REFUND_BIGGEST' | translate}}
									</span>
								</div>
								<div class="voucher-refund__banner-discount--corner u-hide-mobile"></div>
								<div class="u-ml-xsmall">
									<p class="voucher-refund__title">
										{{'MMB_VOUCHER_REFUND_MODAL_TITLE' | translate}}
									</p>
									<p class="voucher-refund__text">
										{{'SEATS_DISRUPTION_REFUND_VOUCHER' | translate}}
									</p>
								</div>
								<div>
									<div class="voucher-refund__item voucher-refund__item--action">
										<div class="voucher-refund__item--action--price">
											<span class="voucher-refund__item--total-quantity">
												{{ voucherRefund.total | customCurrency: voucherRefund.currency}}
											</span>
											<span class="voucher-refund__item--quantity">
												({{ voucherRefund.baseAmount | customCurrency: voucherRefund.currency}}
												<span class="voucher-refund__item--extra-quantity">
													+ {{ voucherRefund.extraAmount | customCurrency: voucherRefund.currency}}
												</span>
												)
											</span>
										</div>
										<button class="ib-button ib-button--h-xmedium ib-button--w-medium" type="button">
											{{'SELECT_BUTTON_TEXT' | translate}}
										</button>
									</div>
									<div class="voucher-refund__items">
										<div class="voucher-refund__item">
											<span class="icon-avion_arriba voucher-refund__item--icon"></span>
											<span class="voucher-refund__item--text" [innerHTML]="translationsMap.get('SEATS_DISRUPTION_REFUND_INSTANT')">
											</span>
										</div>
										<div class="voucher-refund__item">
											<span class="icon-avion_arriba voucher-refund__item--icon"></span>
											<span class="voucher-refund__item--text">
												{{'SEATS_DISRUPTION_REFUND_OPERATORS' | translate}}
											</span>
										</div>
									</div>
									<div class="voucher-refund__items">
										<div class="voucher-refund__item">
											<span class="icon-gestion_de_reservas voucher-refund__item--icon"></span>
											<span class="voucher-refund__item--text" [innerHTML]="translationsMap.get('SEATS_DISRUPTION_REFUND_VALID_ONE_YEAR')">
											</span>
										</div>
										<div class="voucher-refund__item">
											<span class="icon-e-equipaje-23-kg voucher-refund__item--icon u-font-large u-mr-xsmedium u-ml-xsmedium"></span>
											<span class="voucher-refund__item--text" [innerHTML]="translationsMap.get('SEATS_DISRUPTION_REFUND_ANCILLARIES')">
											</span>
										</div>
									</div>
									<div class="voucher-refund__items">
										<div class="voucher-refund__item">
											<span class="icon-calendario voucher-refund__item--icon"></span>
											<span class="voucher-refund__item--text" [innerHTML]="translationsMap.get('SEATS_DISRUPTION_REFUND_A_YEAR_AFTER')">
											</span>
										</div>
										<div class="voucher-refund__item">
											<span class="icon-tarjeta_de_embarque voucher-refund__item--icon" ></span>
											<span class="voucher-refund__item--text"  [innerHTML]="translationsMap.get('SEATS_DISRUPTION_REFUND_USAGES')">
											</span>
										</div>
									</div>
								</div>
							</div>
						</section>
						<section>
							<div class="payment-refund">
								<div>
									<p class="payment-refund__title">
										{{'MMB_REFUNDS_VOUCHER_CASH_TITLE' | translate}}
									</p>
									<p class="payment-refund__text">
										{{'SEATS_DISRUPTION_REFUND_METHOD' | translate}}
									</p>
									<div class="payment-refund__action">
										<span class="payment-refund__total-quantity u-p">
											{{cashRefund.total | customCurrency: cashRefund.currency}}
										</span>
										<button class="ib-button ib-button--inverse ib-button--h-xmedium ib-button--w-medium payment-refund__button" type="button">
											{{'SELECT_BUTTON_TEXT' | translate}}
										</button>
									</div>
								</div>
							</div>
						</section>
						</div>
						<div class="col-xs-12 col-lg-4 info-box">
							<div class="row ib-box-info--equal-height">
								<ib-box-info
									*ngFor="let infoBox of boxInfoModels"
									class="col-xs-12 col-sm-6 col-lg-12"
									[boxInfoModel]="infoBox">
								</ib-box-info>
							</div>
						</div>
				</div>
			</div>
		</section>
	</main>
	<ib-generic-footer
		[iconUrl]="iconUrl">
	</ib-generic-footer>
</div>